var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSeats = function SvgSeats(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00024 0C3.44796 0 3.00024 0.447715 3.00024 1V11H1.28339C0.531516 11 -0.0502185 11.659 0.0430399 12.405L0.453166 15.6861C0.546996 16.4367 1.1851 17 1.94158 17H3.00024V19.5C3.00024 19.7761 3.2241 20 3.50024 20H4.50024C4.77639 20 5.00024 19.7761 5.00024 19.5V17H13.0002V19.5C13.0002 19.7761 13.2241 20 13.5002 20H14.5002C14.7764 20 15.0002 19.7761 15.0002 19.5V17H16.0588C16.8153 17 17.4534 16.4367 17.5472 15.6861L17.9573 12.405C18.0506 11.659 17.4689 11 16.717 11H15.0002V1C15.0002 0.447715 14.5525 0 14.0002 0H4.00024ZM13.0002 11V2H5.00024V11H13.0002ZM4.00024 13H2.13297L2.38297 15H15.6174L15.8674 13H14.0002H4.00024Z",
    fill: "#1B1B1C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSeats, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/seats.1e82f1df.svg";
export { ForwardRef as ReactComponent };